import { fetcher } from "helpers/fetcher";

import { TGetActiveVacanciesReq, TGetActiveVacanciesRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getActiveVacancies = async (payload?: TGetActiveVacanciesReq) => {
  return await fetcher<TGetActiveVacanciesRes, TGetActiveVacanciesReq>(
    ENDPOINT.CORPORATION.GET_ACTIVE_VACANCIES,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.CORPORATION.GET_ACTIVE_VACANCIES.version,
        [API_HEADER.BU_ID]: payload?.idBusinessUnit,
        [API_HEADER.CORP_ID]: payload?.idCorporation,
      },
    }
  );
};

export const queryGetActiveVacancies = async (
  payload?: TGetActiveVacanciesReq
) => {
  return (await getActiveVacancies(payload)).data;
};

queryGetActiveVacancies._key = (
  payload?: TGetActiveVacanciesReq,
  key?: string
) => [ENDPOINT.CORPORATION.GET_ACTIVE_VACANCIES.url, payload, key];
